@if (storageBanner && storageBanner.displayFlag) {
  <div class="info-banner-card warn fx-fill">
    <mat-card-content [ngClass]="storageBanner.cssClass" class="fxl-row fxla-center-center">
      @if (
        storageUsagePercentageWarning <= storageBanner.storageUsagePercentage &&
        storageBanner.storageUsagePercentage < storageUsagePercentageWarning2
      ) {
        <div>
          @if (!subscriptionSettingsFlag) {
            <span>Votre espace de stockage est bientôt saturé.</span>
          }
          @if (subscriptionSettingsFlag) {
            <div>
              <span>Votre espace de stockage est bientôt saturé. Cliquez sur la section </span>
              <a class="text-nowrap" href="/subscription" mat-menu-item>Votre abonnement</a>
              <span> pour plus d'informations.</span>
            </div>
          }
        </div>
      }
      @if (storageBanner.storageUsagePercentage >= storageUsagePercentageWarning2) {
        <div>
          @if (!subscriptionSettingsFlag) {
            <span>Votre espace de stockage est saturé.</span>
          }
          @if (subscriptionSettingsFlag) {
            <div>
              <span>Votre espace de stockage est saturé. Cliquez sur la section </span>
              <a class="text-nowrap" href="/subscription" mat-menu-item>Votre abonnement</a>
              <span> pour plus d'informations.</span>
            </div>
          }
        </div>
      }
    </mat-card-content>
  </div>
}
